import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2beae771"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "pinned-filter",
  "data-i18n-ignore": ""
}
const _hoisted_2 = ["aria-label", "title", "value"]
const _hoisted_3 = { value: "all" }
const _hoisted_4 = { value: "true" }
const _hoisted_5 = { value: "false" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _createElementVNode("select", {
      "aria-label": _ctx.text.label,
      title: _ctx.text.label,
      value: _ctx.modelValue===true?'true':_ctx.modelValue===false?'false':'all',
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.change && _ctx.change(...args)))
    }, [
      _createElementVNode("option", _hoisted_3, _toDisplayString(_ctx.text.options[0]), 1),
      _createElementVNode("option", _hoisted_4, _toDisplayString(_ctx.text.options[1]), 1),
      _createElementVNode("option", _hoisted_5, _toDisplayString(_ctx.text.options[2]), 1)
    ], 40, _hoisted_2)
  ]))
}